import React from 'react';
import { useSelector } from 'react-redux';

import { useIsAuthenticated } from '@azure/msal-react';

import { ExternalLink, LoginButton } from 'features/order-tracker/shared-components';
import { getAEMHeroBannerProps } from 'features/order-tracker/store/selectors';
import { formatAEMImageUri, formatAEMLinkUrl } from 'features/order-tracker/utils';

import styles from './style.module.scss';

export const HeroBanner: React.FC = () => {
  const AEMHeroBannerProps = useSelector(getAEMHeroBannerProps);
  const isAuthenticated = useIsAuthenticated();

  if (!AEMHeroBannerProps) {
    return null;
  }

  const {
    anonymousFeatures,
    authorizedFeatures,
    anonymousSubtitle,
    anonymousTitle,
    authorizedSubtitle,
    authorizedTitle,
    backgroundImage,
    mainButtonLabel,
    mainButtonUrl,
    secondaryButtonLabel,
    secondaryButtonUrl,
  } = AEMHeroBannerProps;
  const formattedImgUri = formatAEMImageUri(backgroundImage);
  const formattedMainButtonUrl = formatAEMLinkUrl(mainButtonUrl);
  const formattedSecondaryButtonUrl = formatAEMLinkUrl(secondaryButtonUrl);
  const title = isAuthenticated ? authorizedTitle : anonymousTitle;
  const subTitle = isAuthenticated ? authorizedSubtitle : anonymousSubtitle;
  const featuresList = isAuthenticated ? authorizedFeatures : anonymousFeatures;

  return (
    <div className={styles.outerContainer}>
      <div className={styles.heroBannerContainer}>
        <div className={styles.content}>
          <h1>{title}</h1>
          <p>{subTitle}</p>
          <ul>
            {featuresList?.map((item) => (
              <li key={item}>{item}</li>
            ))}
          </ul>
          {!isAuthenticated && (
            <div className={styles.buttonContainer}>
              <LoginButton text={mainButtonLabel} url={formattedMainButtonUrl} className={styles.mainButton} />
              <ExternalLink
                text={secondaryButtonLabel || ''}
                link={formattedSecondaryButtonUrl || ''}
                withIcon={false}
                className={styles.secondaryButton}
                target="_blank"
                analytics={secondaryButtonLabel}
              />
            </div>
          )}
        </div>
        <div className={styles.bgImageContainer}>
          <div className={styles.blur} />
          <picture>
            <source media="(min-width: 1600px)" srcSet={`${formattedImgUri}:3200x1400`} />
            <source media="(min-width: 1280px)" srcSet={`${formattedImgUri}:1600x700`} />
            <source media="(min-width: 768px)" srcSet={`${formattedImgUri}:1024x480`} />
            <img src={formattedImgUri} alt="title" loading="eager" />
          </picture>
        </div>
      </div>
    </div>
  );
};
